import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userConfigWrapper: {},
  userConfigForm: {
    marginTop: '8px',
    position: 'relative',
  },
  languageItem: {
    maxWidth: 'unset',
  },
  buttonWrapper: {
    padding: '16px 0',
  },
  buttonActionWrapper: {
    padding: '16px 0',
    position: 'absolute',
    right: '0',
  },

  userConfigContent: {},
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
}));
